import Vue from 'vue'
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

Vue.use(
  VueAxios,
  axios
)

// export const HTTP = Vue.axios.create({
//   baseURL: process.env.VUE_APP_API_URL,
//   // headers: {
//   //   Authorization: 'Bearer {token}'
//   // }
// })

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)


import VueTimepicker from 'vue2-timepicker'

import 'vue2-timepicker/dist/VueTimepicker.css'
Vue.use(VueTimepicker)



Vue.config.productionTip = false

import routes from './routes';


const router = new VueRouter({
  routes
});


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')